import { gql } from '__generated__';

export default gql(`
  mutation SendOrderConfirmation($id: ID!) {
    sendOrderConfirmation(id: $id) {
      id
      to
      subject
      created_at
    }
  }
`);
